var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_found"},[_c('div',{staticClass:"image"},[(_vm.happy)?_c('img',{attrs:{"src":require("@/assets/media/images/Icons/happy-face.png")}}):_c('img',{attrs:{"src":require("@/assets/media/images/Icons/not_found.png")}})]),_c('div',{staticClass:"text"},[_c('h4',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }